import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Nav, Dropdown, Carousel, Table, Form, Button } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import MakeRequest from '../Helpers/MakeRequest';


const EditContact = () => {
    const { l } = useOutletContext();
    const [contactInfo, setContactInfo] = useState({
        content: { sv: '', en: '' },
        addresses: [],
        emails: [],
        phones: []
    });

    useEffect(() => {
        const fetchContactInfo = async () => {
            const contactRes = await MakeRequest({}, 'content/pageContent?page=contact', 'get');
            if (contactRes.data) {
                setContactInfo(contactRes.data[0])
            };
        };
        fetchContactInfo()
    }, []);

    const handleContentChange = (lang, value) => {
        setContactInfo(prev => ({
            ...prev,
            content: { ...prev.content, [lang]: value }
        }));
    };

    const handleFieldChange = (e, idx, type) => {

        const [entity, field] = type.split('-');

        const value = e.target.value;
        const array = [...contactInfo[entity]];
        array[idx] = {
            ...array[idx],
            [field]: value
        };
        setContactInfo(prev => ({ ...prev, [entity]: array }))
    };

    const handleAddField = type => {
        setContactInfo(prev => ({
            ...prev, 
            [type]: [...prev[type], {
                titleSwe: '',
                titleEng: '',
                content: ''
            }]
        }));
    };

    const handleRemoveField = (idx, type) => {
        const entities = contactInfo[type].filter((_, i) => i !== idx);
        setContactInfo(prev => ({ ...prev, [type]: entities }));
    };

    const handleSaveChanges = async () => {
        try {
            const response = await MakeRequest(contactInfo, 'content/pageContent?page=contact', 'post');
            if(response.status === 200){
                alert(l("Kontaktinformation sparades.", "Contact information saved successfully"));
            } else {
                alert(l("Misslyckades att spara kontaktinformation.", "Failed to save contact information"))
            }
        } catch(e){
            alert(l("Misslyckades att spara kontaktinformation.", "Failed to save contact information"))
        };
    };

    const saveDisabled = false;

    return (
        <>
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                        {l("Innehåll (Svenska)", "Content (Swedish)")}
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Control
                            as="textarea"
                            value={contactInfo.content.sv}
                            onChange={e => handleContentChange('sv', e.target.value)}
                        />
                    </Col>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                        {l("Innehåll (Engelska)", "Content (English)")}
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Control
                            as="textarea"
                            value={contactInfo.content.en}
                            onChange={e => handleContentChange('en', e.target.value)}
                        />
                    </Col>
                </Form.Group>

                {/* Addresses */}
                <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                    {l('Adresser', 'Addresses')}
                    <Button
                        size="sm"
                        style={{ marginLeft: 10 }}
                        onClick={() => handleAddField('addresses')}
                        title="Add new row"
                    >
                        <i className="fa-solid fa-plus"></i>
                    </Button>
                </Form.Label>

                <Table striped bordered hover responsive className="d-none d-md-table">
                    <thead>
                        <tr>
                            <th>{l("Titel Svenska", "Title Swedish")}</th>
                            <th>{l("Titel Engelska", "Title English")}</th>
                            <th>{l("Adress", "Address")}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {contactInfo.addresses.map((address, idx) => (
                            <React.Fragment key={idx}>

                                <tr>
                                    {/* SWE title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={address.titleSwe}
                                            onChange={(e) => handleFieldChange(e, idx, "addresses-titleSwe")}
                                        />
                                    </td>

                                    {/* ENG title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={address.titleEng}
                                            onChange={(e) => handleFieldChange(e, idx, "addresses-titleEng")}
                                        />
                                    </td>
                                    {/* Address */}
                                    <td>
                                        <Form.Control
                                            as="textarea"
                                            placeholder={l("Adress", "Address")}
                                            value={address.content}
                                            onChange={(e) => handleFieldChange(e, idx, "addresses-content")}
                                        />
                                    </td>

                                    {/* delete button */}
                                    <td>
                                        <Button onClick={() => handleRemoveField(idx, 'addresses')}>
                                            <i className="fa-solid fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>

                {/* Emails */}
                <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                    {l('Email-adresser', 'Email addresses')}
                    <Button
                        size="sm"
                        style={{ marginLeft: 10 }}
                        onClick={() => handleAddField('emails')}
                        title="Add new row"
                    >
                        <i className="fa-solid fa-plus"></i>
                    </Button>
                </Form.Label>

                <Table striped bordered hover responsive className="d-none d-md-table">
                    <thead>
                        <tr>
                            <th>{l("Titel Svenska", "Title Swedish")}</th>
                            <th>{l("Titel Engelska", "Title English")}</th>
                            <th>{l("Email-adress", "Email address")}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {contactInfo.emails.map((email, idx) => (
                            <React.Fragment key={idx}>

                                <tr>
                                    {/* SWE title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={email.titleSwe}
                                            onChange={(e) => handleFieldChange(e, idx, "emails-titleSwe")}
                                        />
                                    </td>

                                    {/* ENG title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={email.titleEng}
                                            onChange={(e) => handleFieldChange(e, idx, "emails-titleEng")}
                                        />
                                    </td>
                                    {/* Address */}
                                    <td>
                                        <Form.Control
                                            as="textarea"
                                            placeholder={l("Email-adress", "Email address")}
                                            value={email.content}
                                            onChange={(e) => handleFieldChange(e, idx, "emails-content")}
                                        />
                                    </td>

                                    {/* delete button */}
                                    <td>
                                        <Button onClick={() => handleRemoveField(idx, 'emails')}>
                                            <i className="fa-solid fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>

                {/* Addresses */}
                <Form.Label column sm={2} style={{ fontWeight: 'bold' }}>
                    {l('Telefonnummer', 'Phone numbers')}
                    <Button
                        size="sm"
                        style={{ marginLeft: 10 }}
                        onClick={() => handleAddField('phones')}
                        title="Add new row"
                    >
                        <i className="fa-solid fa-plus"></i>
                    </Button>
                </Form.Label>

                <Table striped bordered hover responsive className="d-none d-md-table">
                    <thead>
                        <tr>
                            <th>{l("Titel Svenska", "Title Swedish")}</th>
                            <th>{l("Titel Engelska", "Title English")}</th>
                            <th>{l("Telefonnummer", "Phone number")}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {contactInfo.phones.map((phone, idx) => (
                            <React.Fragment key={idx}>

                                <tr>
                                    {/* SWE title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={phone.titleSwe}
                                            onChange={(e) => handleFieldChange(e, idx, "phones-titleSwe")}
                                        />
                                    </td>

                                    {/* ENG title */}
                                    <td>
                                        <Form.Control
                                            type="text"
                                            placeholder={l("Titel", "Title")}
                                            value={phone.titleEng}
                                            onChange={(e) => handleFieldChange(e, idx, "phones-titleEng")}
                                        />
                                    </td>
                                    {/* Address */}
                                    <td>
                                        <Form.Control
                                            as="textarea"
                                            placeholder={l("Telefonnummer", "Phone number")}
                                            value={phone.content}
                                            onChange={(e) => handleFieldChange(e, idx, "phones-content")}
                                        />
                                    </td>

                                    {/* delete button */}
                                    <td>
                                        <Button onClick={() => handleRemoveField(idx, 'phones')}>
                                            <i className="fa-solid fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>

            </Form>
            <Row className="d-flex justify-content-center">
                <Button style={{ width: "200px" }} onClick={handleSaveChanges} disabled={saveDisabled}>
                    {l("Spara ändringar", "Save Changes")}
                </Button>
            </Row>
        </>
    );
};

export default EditContact;